import script from "./EntityDetailPresentation.vue?vue&type=script&setup=true&lang=js"
export * from "./EntityDetailPresentation.vue?vue&type=script&setup=true&lang=js"

import "./EntityDetailPresentation.vue?vue&type=style&index=0&id=1c501eac&lang=scss&scoped=true"

import exportComponent from "/Users/cricle/Documents/monetware/code/web/knowledgeGraph-html/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c501eac"]])

export default __exports__